module.exports = __webpack_public_path__ + "img/13_BC14_cultivate_a_pod.95880aa5.jpg";